import { Link } from "react-router-dom";
import { renderCustomColumnDefs } from "../../../../shared/Table/table.utils";
import { formatDate, renderAmount } from "../../../../utils";

// Config for Job report UI table
const tableConfig = [
  {
    id: "jobId",
    header: "Job ID",
    minWidth: 120,
    cell: ({ getValue, row }) => {
      const value = getValue();
      const rowId = row.original._id;
      if (rowId) {
        return (
          <Link
            to={`/jobs/${rowId}`}
            className="text-primary-600 hover:underline cursor-pointer"
          >
            {value || rowId}
          </Link>
        );
      }
      return value || "-";
    },
  },
  {
    id: "appointmentDate",
    header: "Appointment Date",
    minWidth: 150,
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) return "-";
      return formatDate(value);
    },
  },
  {
    id: "loadNumber",
    header: "Load Number",
    minWidth: 130,
    cell: ({ getValue }) => getValue() || "-",
  },
  {
    id: "client",
    header: "Client",
    minWidth: 150,
    cell: ({ getValue }) => {
      const client = getValue();
      if (!client) return "-";
      if (typeof client === "string") return client;
      return client?.name || client?.fullName || "-";
    },
  },
  {
    id: "status",
    header: "Status",
    minWidth: 100,
    cell: ({ getValue }) => getValue() || "-",
  },
  {
    id: "hourlyTotal",
    header: "Labor Total",
    minWidth: 120,
    cell: ({ getValue }) => renderAmount(getValue()),
  },
  {
    id: "partsTotal",
    header: "Parts Total",
    minWidth: 120,
    cell: ({ getValue }) => renderAmount(getValue()),
  },
  {
    id: "serviceFeeTotal",
    header: "Service Fee",
    minWidth: 120,
    cell: ({ getValue }) => renderAmount(getValue()),
  },
  {
    id: "calculatedTotalCharges",
    header: "Gross",
    minWidth: 120,
    cell: ({ getValue }) => renderAmount(getValue()),
  },
];

export const COLUMN_DEFINITIONS = renderCustomColumnDefs(tableConfig);










